import { BASE_API_URL } from '../constants';

export const getImageUrl = (path: string) => {
  return `${BASE_API_URL}/${path}`;
};
